import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'app-small-card-button',
  templateUrl: './small-card-button.component.html',
  styleUrls: ['./small-card-button.component.css'],
})
export class SmallCardButtonComponent implements OnInit {
  @ContentChild('image') image!: TemplateRef<any>;
  @ContentChild('title') title!: TemplateRef<any>;
  @ContentChild('subTitle') subTitle?: TemplateRef<any>;
  @Input() disabled: boolean = false;

  @Output() selected: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  submit() {
    if (!this.disabled) this.selected.emit();
  }
}
